/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdmissionStatusCode } from './AdmissionStatusCode';
import {
    AdmissionStatusCodeFromJSON,
    AdmissionStatusCodeFromJSONTyped,
    AdmissionStatusCodeToJSON,
    AdmissionStatusCodeToJSONTyped,
} from './AdmissionStatusCode';

/**
 * 
 * @export
 * @interface LegalTransition
 */
export interface LegalTransition {
    /**
     * Target admission-status code. `none` on a `revert` means
     * the revert clears the status entirely.
     * 
     */
    to_status: AdmissionStatusCode;
    /**
     * `allowed` — render and clickable.
     * `disabled` — render but greyed out (caller should also read `reason`).
     * `absent` — do not render.
     * 
     */
    verdict: LegalTransitionVerdictEnum;
    /**
     * `revert` is the back-edge to the lead's immediately-previous
     * status (rendered as Undo). `forward` is everything else.
     * 
     */
    kind: LegalTransitionKindEnum;
    /**
     * Populated when `verdict` is `disabled`.
     */
    reason?: string;
}


/**
 * @export
 */
export const LegalTransitionVerdictEnum = {
    Allowed: 'allowed',
    Absent: 'absent',
    Disabled: 'disabled',
} as const;
export type LegalTransitionVerdictEnum = typeof LegalTransitionVerdictEnum[keyof typeof LegalTransitionVerdictEnum];

/**
 * @export
 */
export const LegalTransitionKindEnum = {
    Forward: 'forward',
    Revert: 'revert',
} as const;
export type LegalTransitionKindEnum = typeof LegalTransitionKindEnum[keyof typeof LegalTransitionKindEnum];


/**
 * Check if a given object implements the LegalTransition interface.
 */
export function instanceOfLegalTransition(value: object): value is LegalTransition {
    if (!('to_status' in value) || value['to_status'] === undefined) return false;
    if (!('verdict' in value) || value['verdict'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function LegalTransitionFromJSON(json: any): LegalTransition {
    return LegalTransitionFromJSONTyped(json, false);
}

export function LegalTransitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalTransition {
    if (json == null) {
        return json;
    }
    return {
        
        'to_status': AdmissionStatusCodeFromJSON(json['to_status']),
        'verdict': json['verdict'],
        'kind': json['kind'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function LegalTransitionToJSON(json: any): LegalTransition {
    return LegalTransitionToJSONTyped(json, false);
}

export function LegalTransitionToJSONTyped(value?: LegalTransition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'to_status': AdmissionStatusCodeToJSON(value['to_status']),
        'verdict': value['verdict'],
        'kind': value['kind'],
        'reason': value['reason'],
    };
}

